import { SurveyUserStatus, SurveyStatus } from '@/api/v2/requests/surveys';
export const StatusBackgroundColor = {
    REJECTED: '#FFE6E8',
    IN_VERIFICATION: '#FFF2CF',
    APPROVED: '#D1F9EE',
    NEEDS_REVISION: '#FFEBDF',
    WAITING: '#DEF3FA',
};
const baseStyle = {
    textTransform: 'uppercase',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: 'bold',
    width: 'fit-content',
};
const surveyStatusPadding = {
    padding: '8px 12px',
};
export const surveyStatusStyles = {
    [SurveyStatus.WAITING]: {
        backgroundColor: StatusBackgroundColor.WAITING,
        color: '#00A4E1',
        ...surveyStatusPadding,
        ...baseStyle,
    },
    [SurveyStatus.IN_VERIFICATION]: {
        backgroundColor: StatusBackgroundColor.IN_VERIFICATION,
        color: '#EBB600',
        ...surveyStatusPadding,
        ...baseStyle,
    },
    [SurveyStatus.NEEDS_REVISION]: {
        backgroundColor: StatusBackgroundColor.NEEDS_REVISION,
        color: '#FF7A30',
        ...surveyStatusPadding,
        ...baseStyle,
    },
    [SurveyStatus.REJECTED]: {
        backgroundColor: StatusBackgroundColor.REJECTED,
        color: '#DB0012',
        ...surveyStatusPadding,
        ...baseStyle,
    },
    [SurveyStatus.APPROVED]: {
        backgroundColor: StatusBackgroundColor.APPROVED,
        color: '#00BA89',
        ...surveyStatusPadding,
        ...baseStyle,
    },
};
export const surveyStatusOptionStyles = {
    [SurveyUserStatus.IN_VERIFICATION]: {
        backgroundColor: StatusBackgroundColor.IN_VERIFICATION,
        color: '#EBB600',
        padding: '7px 12px',
        ...baseStyle,
    },
    [SurveyUserStatus.REJECTED]: {
        backgroundColor: StatusBackgroundColor.REJECTED,
        color: '#DB0012',
        padding: '7px 12px',
        ...baseStyle,
    },
    [SurveyUserStatus.APPROVED]: {
        backgroundColor: StatusBackgroundColor.APPROVED,
        color: '#00BA89',
        padding: '7px 12px',
        ...baseStyle,
    },
};
